import {Button, Grid, Radio} from '@logistics-frontend/blocks'
import React from 'react'

import {ChangeCardModal} from '../ChangeCardModal/ChangeCardModal'
import {useProps} from './hooks'
import {type Props} from './types'

export function ChangeCard(props: Props): React.ReactElement {
  const {buttonProps, radioProps, changeCardModalProps} = useProps(props)

  return (
    <>
      <Grid size="s" wrap="nowrap" container>
        <Grid item>
          <Button data-e2e="change-card" {...buttonProps} />
        </Grid>
        {radioProps && (
          <Grid item>
            <Radio {...radioProps} />
          </Grid>
        )}
      </Grid>
      {changeCardModalProps && <ChangeCardModal {...changeCardModalProps} />}
    </>
  )
}
